import { render } from "./IconCompareEyes.vue?vue&type=template&id=11449e84&lang=html"
import script from "./IconCompareEyes.vue?vue&type=script&lang=js"
export * from "./IconCompareEyes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__